/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:6c8bb50c-0bd0-4814-a43b-8075baf25117",
    "aws_cognito_region": "us-east-1",
    "oauth": {},
    "XR": {
        "scenes": {
            "nsamplifytest": {
                "sceneConfig": {
                    "sceneId": "4fa8ec6dd29b42ee85d797c8b6253658.scene",
                    "region": "us-east-1",
                    "projectName": "North Split VR Public Room",
                    "url": "https://sumerian.us-east-1.amazonaws.com/20180801/projects/North%20Split%20VR%20Public%20Room/release/authTokens?sceneId=4fa8ec6dd29b42ee85d797c8b6253658.scene"
                }
            },
            "nsvpo": {
                "sceneConfig": {
                    "sceneId": "4fa8ec6dd29b42ee85d797c8b6253658.scene",
                    "region": "us-east-1",
                    "projectName": "North Split VR Public Room",
                    "url": "https://sumerian.us-east-1.amazonaws.com/20180801/projects/North%20Split%20VR%20Public%20Room/release/authTokens?sceneId=4fa8ec6dd29b42ee85d797c8b6253658.scene"
                }
            }
        }
    }
};


export default awsmobile;
